import { defineStore } from 'pinia'

import state from './accounts.state'
import getters from './accounts.getters'
import actions from './accounts.actions'

/**
 * Returns Accounts store
 */
export const useAccountsStore = defineStore('accounts', {
  state: () => state,
  getters,
  actions
})
